export default {
  US: {
    AL: 'Alabama',
    AK: 'Alaska',
    AS: 'Amerikanischen Samoa-Inseln',
    AZ: 'Arizona',
    AR: 'Arkansas',
    AA: 'Streitkräfte Amerikas',
    AE: 'Streitkräfte Europa',
    AP: 'Streitkräfte Pazifik',
    CA: 'Kalifornien',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District of Columbia',
    FM: 'Die Verbündeten Staaten von Micronesia',
    FL: 'Florida',
    GA: 'Georgia',
    GU: 'Guam',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MH: 'Marshallinseln',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New-Mexiko',
    NY: 'New York',
    NC: 'Nordkarolina',
    ND: 'Norddakota',
    MP: 'Nördliche Marianneninseln',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PW: 'Palau',
    PA: 'Pennsylvania',
    PR: 'Puerto-Rico',
    RI: 'Rhode Island',
    SC: 'Südkarolina',
    SD: 'Süddakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UM: 'Kleinere vorgelagerte Inseln der Vereinigten Staaten',
    UT: 'Utah',
    VT: 'Vermont',
    VI: 'Jungferninseln',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
  },
  CA: {
    AB: 'Alberta',
    BC: 'Britisch-Kolumbien',
    MB: 'Manitoba',
    NB: 'New Brunswick',
    NL: 'Neufundland',
    NT: 'Nordwestliche Territorien',
    NS: 'Neuschottland',
    NU: 'Nunavut',
    ON: 'Ontario',
    PE: 'Prinz Edward Insel',
    QC: 'Québec',
    SK: 'Saskatchewan',
    YT: 'Yukon',
  },
  CN: {
    AH: 'Anhui',
    BJ: 'Beijing',
    CQ: 'Chongqing',
    FJ: 'Fujian',
    GS: 'Gansu',
    GD: 'Guangdong',
    GX: 'Guangxi',
    GZ: 'Guizhou',
    HI: 'Hainan',
    HE: 'Hebei',
    HL: 'Heilongjiang',
    HA: 'Henan',
    HK: 'Hong Kong SAR',
    HB: 'Hubei',
    HN: 'Hunan',
    JS: 'Jiangsu',
    JX: 'Jiangxi',
    JL: 'Jilin',
    LN: 'Liaoning',
    MO: 'Macao SAR',
    NM: 'Nei Mongol',
    NX: 'Ningxia',
    QH: 'Qinghai',
    SN: 'Shaanxi',
    SD: 'Shandong',
    SH: 'Shanghai',
    SX: 'Shanxi',
    SC: 'Sichuan',
    TW: 'Taiwan',
    TJ: 'Tianjin',
    XJ: 'Xinjiang',
    XZ: 'Xizang',
    YN: 'Yunnan',
    ZJ: 'Zhejiang',
  },
};
